import { Avatar } from '~/components/Avatar'
import { OrgMember } from '~/types'

const DEFAULT_PROFILE_PHOTO =
  'https://assets.splits.org/default_profile_photo.png'

export const UserAvatar = ({
  user,
  size = 20,
}: {
  size?: number
  user: Pick<OrgMember, 'email' | 'displayName' | 'profilePhotoUrl'>
}) => {
  const { email, displayName, profilePhotoUrl } = user

  return (
    <Avatar
      image={profilePhotoUrl ?? undefined}
      // Default photo only backs a broken URL; no photo falls to the initial
      fallbackImage={profilePhotoUrl ? DEFAULT_PROFILE_PHOTO : undefined}
      initial={(displayName ?? email).at(0)?.toUpperCase()}
      alt={`Avatar for ${displayName ?? email}`}
      size={size}
    />
  )
}
